import React from 'react';
import classNames from 'classnames';
import genSkeletonItems from 'utils/genSkeletonItems';
import entryLoop from 'utils/entryLoop';
import { getNextID } from 'utils/elementIDCreator';
import withLoadingError from 'components/hoc/withLoadingError';
import RenderPropType from 'utils/ts/RenderPropType';

const SummaryList: React.SFC<PropDef> = ({
  'data-test': dataTest,
  types,
  ...args
}) => (
  <div
    className={classNames(
      'summary-list',
      types.map(type => `summary-list--${type}`),
    )}
    data-test={dataTest}
  >
    {SummaryListContent(args)}
  </div>
);

SummaryList.defaultProps = {
  types: [],
  renderItem: () => null,
};

interface PropDef {
  renderItem();
  'data-test'?: string;
  types?: string[];
}

const SummaryListContent: React.SFC<ContentProps> = ({
  items,
  renderItem,
}) => (
  items
    ? (
      <ul className="summary-list__items">
        {entryLoop(
          item => (
            <li key={item.id || getNextID()} className="summary-list__item">
              {renderItem(item)}
            </li>
          ),
          items,
        )}
      </ul>
    ) : null
);

SummaryListContent.defaultProps = {
  renderItem: () => null,
};

interface ContentProps {
  renderItem: RenderPropType;
  items?: object[];
}

export default withLoadingError({
  renderLoading: props => (
    <SummaryListContent
      items={genSkeletonItems(12, 'list-item')}
      renderItem={props.renderSkeletonItem}
    />
  ),
})(SummaryList);

